const boilerplate01 =
`# We respect your privacy​

This is the web site of ***AGENCY NAME***

Our postal address:

***AGENCY NAME***

*STREET ADDRESS 1*

*STREET ADDRESS 2*

*CITY, STATE ZIP*


Our phone number:

*PHONE NUMBER*

We can also be reached via e-mail at the ICJIA's Information Clearinghouse:

[EMAIL_ADDRESS](mailto:EMAIL_ADDRESS)

Questions about the website should be directed to:

[CONTACT_NAME](mailto:CONTACT_NAME)

For each visitor to our Web page, our Web server automatically recognizes the visitor's IP address.

We collect the domain name of users to our Web page, the e-mail addresses of those who communicate with us via e-mail, and aggregate information on what pages visitors access or visit and information volunteered by the visitor -- such as survey information and/or site registrations.

The information we collect is used to improve our web content and services. If you want to receive e-mail from us in the future, please let us know by sending email to us at the above address or writing to us at the above address and telling us that you want to receive e-mail from our agency.

Persons who supply us with their telephone numbers on-line may receive telephone contact from us with information regarding orders they have placed on-line.`
export {boilerplate01}



// WEBPACK FOOTER //
// ./src/boilerplates/boilerplate01.js